let activeTab = 'size-chart';

function escapeHtml(value) {
  return String(value ?? '')
    .replaceAll('&', '&amp;')
    .replaceAll('<', '&lt;')
    .replaceAll('>', '&gt;')
    .replaceAll('"', '&quot;')
    .replaceAll("'", '&#39;');
}

function renderSizeChartTable(section) {
  const columns = Array.isArray(section.columns) ? section.columns : [];
  const rows = Array.isArray(section.rows) ? section.rows : [];

  const thead = columns.length
    ? `
      <thead>
        <tr>
          ${columns.map((column) => `<th>${escapeHtml(column)}</th>`).join('')}
        </tr>
      </thead>
    `
    : '';

  const tbody = rows.length
    ? `
      <tbody>
        ${rows
          .map(
            (row) => `
              <tr>
                ${(Array.isArray(row) ? row : []).map((cell) => `<td>${escapeHtml(cell)}</td>`).join('')}
              </tr>
            `
          )
          .join('')}
      </tbody>
    `
    : '';

  return `
    <section class="size-chart-section">
      ${section.title ? `<h3 class="size-chart-section__title">${escapeHtml(section.title)}</h3>` : ''}
      ${section.description ? `<p class="size-chart-section__description">${escapeHtml(section.description)}</p>` : ''}
      <table class="size-chart-table">
        ${thead}
        ${tbody}
      </table>
    </section>
  `;
}

function renderSizeChart(data) {
  const title = data?.title ? `<h2 id="GlobalSizeChartTitle">${escapeHtml(data.title)}</h2>` : '';

  return `
    ${title}

    <div class="size-guide-tabs">
      <button class="size-guide-tab is-active" data-tab="size-chart">Size Chart</button>
      <button class="size-guide-tab" data-tab="international">International Measurment</button>
    </div>

    <div class="size-guide-content">

      <!-- SIZE CHART TAB -->
      <div class="size-guide-panel" data-panel="size-chart">
        ${data?.description ? `<p class="size-guide-description">${escapeHtml(data.description)}</p>` : ''}

        ${
          Array.isArray(data?.sections)
            ? data.sections
                .filter((section) => section?.type === 'table')
                .map(renderSizeChartTable)
                .join('')
            : ''
        }
      </div>

      <!-- INTERNATIONAL TAB -->
      <div class="size-guide-panel" data-panel="international" hidden>
        <p class="size-guide-description">
          Sizing for clothing, loungewear, and swim styles that are available in sizes XXS to 4X.
        </p>

        <div class="size-guide-table-wrap">
          <table class="size-chart-table">
            <thead>
              <tr>
                <th></th>
                <th>US</th>
                <th>UK/AUS</th>
                <th>EU</th>
                <th>IT</th>
                <th>FR</th>
                <th>JP</th>
              </tr>
            </thead>
            <tbody>
              <tr><td>XXS</td><td>00</td><td>0</td><td>28</td><td>34</td><td>30</td><td>3</td></tr>
              <tr><td>XS</td><td>0-2</td><td>4-6</td><td>30-32</td><td>36-38</td><td>32-34</td><td>5-7</td></tr>
              <tr><td>S</td><td>4-6</td><td>8-10</td><td>34-36</td><td>40-42</td><td>36-38</td><td>9-11</td></tr>
              <tr><td>M</td><td>8-10</td><td>12-14</td><td>38-40</td><td>44-46</td><td>40-42</td><td>13-15</td></tr>
              <tr><td>L</td><td>12-14</td><td>16-18</td><td>42-44</td><td>48-50</td><td>44-46</td><td>17-19</td></tr>
              <tr><td>XL</td><td>16</td><td>20</td><td>46</td><td>52</td><td>48</td><td>21</td></tr>
              <tr><td>2X</td><td>18-20</td><td>22-24</td><td>48-50</td><td>54-56</td><td>50-52</td><td>23-27</td></tr>
              <tr><td>3X</td><td>22-24</td><td>26-28</td><td>52-54</td><td>58-60</td><td>54-56</td><td>27-29</td></tr>
              <tr><td>4X</td><td>26-28</td><td>30-32</td><td>56-58</td><td>62-64</td><td>58-60</td><td>31-33</td></tr>
            </tbody>
          </table>
        </div>
      </div>

    </div>
  `;
}

document.addEventListener('click', function (e) {

  const tabBtn = e.target.closest('[data-tab]');
  if (tabBtn) {
    e.preventDefault();

    const tab = tabBtn.getAttribute('data-tab');
    const modal = document.getElementById('GlobalSizeChartModal');
    if (!modal) return;

    const tabs = modal.querySelectorAll('[data-tab]');
    const panels = modal.querySelectorAll('[data-panel]');

    tabs.forEach((btn) => {
      btn.classList.toggle('is-active', btn === tabBtn);
    });

    panels.forEach((panel) => {
      panel.hidden = panel.getAttribute('data-panel') !== tab;
    });

    return;
  }

  const openBtn = e.target.closest('[data-size-chart-open]');
  if (openBtn) {
    e.preventDefault();

    const productId = openBtn.getAttribute('data-size-chart-product-id');
    if (!productId) return;

    const dataScript = document.getElementById(`SizeChartData-${productId}`);
    if (!dataScript) return;

    let data;
    try {
      data = JSON.parse(dataScript.textContent);
    } catch (error) {
      console.error('Failed to parse size chart JSON', error);
      return;
    }

    const modal = document.getElementById('GlobalSizeChartModal');
    const content = document.getElementById('GlobalSizeChartContent');
    if (!modal || !content) return;

    content.innerHTML = renderSizeChart(data);
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('size-chart-open');
    return;
  }

  const closeBtn = e.target.closest('[data-size-chart-close]');
  if (closeBtn) {
    e.preventDefault();

    const modal = document.getElementById('GlobalSizeChartModal');
    if (!modal) return;

    modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('size-chart-open');
  }
});

document.addEventListener('keydown', function (e) {
  if (e.key !== 'Escape') return;

  const modal = document.getElementById('GlobalSizeChartModal');
  if (!modal || modal.getAttribute('aria-hidden') !== 'false') return;

  modal.setAttribute('aria-hidden', 'true');
  document.body.classList.remove('size-chart-open');
});